<template>
  <div :class="this.class">
    <div
      class="w-full flex flex-row justify-between cursor-pointer"
      @click="unfoldContent"
    >
      <p class="block text-sm font-medium text-gray-700">{{ title }}</p>
      <div>
        <ArrowDownIcon
          class="w-4 h-4 fill-gray-400 transition"
          :class="unfolded ? '!rotate-90' : '!-rotate-90'"
        />
      </div>
    </div>
    <div ref="accordionContent" class="accordion-content">
      <hr class="my-3" />
      <slot></slot>
    </div>
  </div>
</template>

<script>
import ArrowDownIcon from "../icon/ArrowDownIcon.vue";

export default {
  name: "SingleAccordion",
  components: { ArrowDownIcon },
  props: {
    title: {
      type: String,
      default: "",
    },
    class: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      unfolded: false,
    };
  },
  methods: {
    unfoldContent() {
      if (this.$refs.accordionContent.style.maxHeight) {
        this.$refs.accordionContent.style.maxHeight = null;
        this.unfolded = false;
      } else {
        this.$refs.accordionContent.style.maxHeight =
          this.$refs.accordionContent.scrollHeight + "px";
        this.unfolded = true;
      }
    },
  },
};
</script>
<style scoped>
.accordion-content {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.2s ease-out;
}
</style>
